import PubSub from "pubsub-js";
import gsap from 'gsap';

var ModalEBrochure = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ModalEBrochure',
	};

	$.extend(true, this.options, options);

};

ModalEBrochure.prototype.init = function() {

	var self = this;

	this.$modal = this.options.$el.find(`.${self.options.baseClass}__modal`);
	this.$closeXSpans = self.options.$el.find(`.${self.options.baseClass}__closeX span`);
	this.$firstCloseXSpan = self.options.$el.find(`.${self.options.baseClass}__closeX span:first-child`);
	this.$secondCloseXSpan = self.options.$el.find(`.${self.options.baseClass}__closeX span:last-child`);
	this.$floorPlanSelectors = self.options.$el.find(`.${self.options.baseClass}__floorPlanSelector`);
	this.$form = self.options.$el.find(`form`);
	this.$floorPlanErrorMessage = self.options.$el.find(`.${self.options.baseClass}__floorPlanSelectError`);
	this.$loader = self.options.$el.find(`.${self.options.baseClass}__loader`);

	$('[href="#open-ebrochure-modal"]').on('click', function(e) {

		e.preventDefault();
		self.open();

	});

	this.initAnimationTimelines();

	this.options.$el.find(`.${self.options.baseClass}__closeX`).on('click', function(e) {

		e.stopPropagation(); // prevent our overlay background click event from triggering the fast close timeline
		self.close();

	});

	$(document).keyup(function(e) {
		if (e.keyCode === 27) self.close();
	});

	this.options.$el.on('click', function() {

		self.fastClose();

	});

	this.$modal.on('click', function(e) {

		e.stopPropagation();

	});

	// pubsub events
	PubSub.subscribe('ModalEBrochure:open', function(unitId) {
	    console.log('open modal');
		self.open();

	});

	PubSub.subscribe('ModalEBrochure:close', function() {
	    
		self.close();

	});

	this.overlayScrollbars();

	this.$floorPlanSelectors.on('click', function() {

		let floorPlanId = $(this).data('id');
		let $formCheckbox = self.options.$el.find(`form [data-fui-id="e-brochure-interested-in"] input[value="${floorPlanId}"]`);

		if ($formCheckbox.is(':checked')) {
			// item was selected, deselect
			$formCheckbox.prop('checked', false);
			$(this).removeClass(`${self.options.baseClass}__floorPlanSelector--active`);
		}
		else {
			// item not selected, select it
			$formCheckbox.prop('checked', true);
			$(this).addClass(`${self.options.baseClass}__floorPlanSelector--active`);
		}

	});

	// make sure floor plans are selected, if they're not show our custom error message below the submit button
	this.$form.on('onFormieValidate', function(e) {

		let floorPlansSelectedCount = self.$form.find(`[name="fields[interestedIn][]"]:checked`).length;

		if (floorPlansSelectedCount) {
			self.hideFloorPlanErrorMsg();
		}
		else {
			self.showFloorPlanErrorMsg();

		}

	});

};

ModalEBrochure.prototype.overlayScrollbars = function() {

	let self = this;

	let breakpoint = window.Breakpoint.value;

	// overlay scroll bars
	this.overlayScrollbarsInstance = this.options.$el.find(`.${self.options.baseClass}__modal`).overlayScrollbars({
		className: "os-theme-dark"
	}).overlayScrollbars();
	this.overlayScrollbarsInstanceLeft = this.options.$el.find(`.${self.options.baseClass}__left`).overlayScrollbars({
		className: "os-theme-dark"
	}).overlayScrollbars();
	this.overlayScrollbarsInstanceRight = this.options.$el.find(`.${self.options.baseClass}__right`).overlayScrollbars({
		className: "os-theme-dark"
	}).overlayScrollbars();

};

ModalEBrochure.prototype.showFloorPlanErrorMsg = function() {

	let self = this;

	this.$floorPlanErrorMessage.attr("style", "display: block !important");

};

ModalEBrochure.prototype.hideFloorPlanErrorMsg = function() {

	let self = this;

	this.$floorPlanErrorMessage.attr("style", "display: none !important");

};

ModalEBrochure.prototype.showLoader = function() {

	let self = this;

	gsap.timeline()
	.set(self.$loader, {
		zIndex: 2,
		visibility: 'visible',
	})
	.to(self.$loader, {
		opacity: 1
	});

};

ModalEBrochure.prototype.hideLoader = function() {

	let self = this;

	gsap.timeline()
	.to(self.$loader, {
		opacity: 0
	})
	.set(self.$loader, {
		zIndex: -1,
		visibility: 'hidden',
	});

};

ModalEBrochure.prototype.initAnimationTimelines = function() {

	var self = this;

	this.openTimeline = gsap.timeline(
		{
			paused: true,
			// repeat: -1
		}
	)
	.add(function() {
		// self.overlayScrollbarsInstance.scroll([ 0, 0 ]);
	})
	// .set(self.$modalContent,
	// 	{
	// 		opacity: 0,
	// 		scale: 0.95,
	// 	}
	// )
	.set(self.options.$el,
		{
			visibility: 'visible',
			zIndex: 2003,
		}
	)
	.to(self.options.$el,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 1,
		}
	)
	.to(self.$modal,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 1,
			y: 0,
		},
		"<"
	)
	// .to(self.$modalContent,
	// 	{
	// 		duration: 0.45,
	// 		ease: "power1.out",
	// 		opacity: 1,
	// 		scale: 1,
	// 	},
	// 	">-0.3"
	// )
	// close x
	.from(self.$closeXSpans,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.out"
		}
	)
	.from(self.$closeXSpans,
		{
			duration: 0.25,
			rotate: 0,
			ease: "power1.inOut"
		},
		">-0.1"
	);

	// close
	this.closeTimeline = gsap.timeline(
		{
			paused: true,	
		}
	)
	.to(self.$closeXSpans,
		{
			duration: 0.25,
			rotate: 0,
			ease: "power1.inOut"
		}
	)
	.to(self.$closeXSpans,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.in"
		},
		">-0.1"
	)
	.to(self.options.$el,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 0,
		},
		">-0.1"
	)
	.set(self.options.$el,
		{
			visibility: 'hidden',
			zIndex: -1,
		}
	)
	.add(function() {
		self.hideFloorPlanErrorMsg();
		self.hideLoader();
	});

	// fast close
	this.fastCloseTimeline = gsap.timeline(
		{
			paused: true,	
		}
	)
	.to(self.options.$el,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 0,
		},
		">-0.1"
	)
	.set(self.options.$el,
		{
			visibility: 'hidden',
			zIndex: -1,
		}
	)
	.add(function() {
		self.hideFloorPlanErrorMsg();
		self.hideLoader();
	});

};

ModalEBrochure.prototype.open = function(unitId) {

	var self = this;

	$('body').addClass('disable-scroll');

	// scrollbars need to be shown/hidden via css class, because they are added dynamically via third-party plugin
	self.options.$el.removeClass(`${self.options.baseClass}--showScrollbars`);

	this.openTimeline.restart();

	this.startLoadTime = Date.now();

};

ModalEBrochure.prototype.close = function() {

	$('body').removeClass('disable-scroll');

	this.closeTimeline.restart();

};

ModalEBrochure.prototype.fastClose = function() {

	$('body').removeClass('disable-scroll');

	this.fastCloseTimeline.restart();

};

export default ModalEBrochure;
